export interface TSpecialCondition {
    SpecialConditionId: string;
    Name: string;
    AdjustmentType: eAdjustmentType;
    IsActive: boolean;
    CalculationMode: eCalculationMode;
    Value: number;
    InstallmentCount: number;
}

export enum eAdjustmentType
{
    Surcharge = 0,
    Discount = 1
}

export enum eCalculationMode
{
    FixedValue = 0,
    Percentage = 1
}